declare global {
  interface String {
    /** Returns the string as a key for i18n localization */
    toI18nKey(): string;
    /** Normalizes spaces to underscores */
    normalizeSpaces(): string;
  }
}

String.prototype.toI18nKey = function (this: string): string {
  return this.toLowerCase().replaceAll(" ", "_");
};


/**
 * Normalize spaces in a string to regular spaces.
 * Handles things like non‑breaking and narrow no‑breaking spaces
 *
 * @param {string} this - Original text that may contain special spaces.
 * @returns {string} String with all whitespace normalized to regular spaces.
 *
 * @example
 * "is\u202FSuccess".normalizeSpaces(); // "is Success"
 */
String.prototype.normalizeSpaces = function (this: string): string {
  // Matches various types of Unicode spaces that can cause layout issues,
  // including non‑breaking space (\u00A0), narrow no‑break space (\u202F), etc.
  const specialSpacesRegex =
    /[\u00A0\u1680\u180E\u2000-\u200B\u202F\u205F\u3000]/g;

  return this.replaceAll(specialSpacesRegex, " ");
};

export {};
